import React from 'react';
import './Tag.css'
function Tag({tagName}) {
    return (
        <div className="tagName">
            <span className="dropColor"></span>
            <h2>
                {tagName}
            </h2>
        </div>
    );
}

export default Tag;